// ESTADOS PARA HOME
export const dataTeam = state => state.dataTeam
